import style from './Loading.module.scss';

const Loading = () => {
	return (
		<div className={style['dot-spinner']}>
			<div className={style['dot-spinner__dot']}></div>
			<div className={style['dot-spinner__dot']}></div>
			<div className={style['dot-spinner__dot']}></div>
			<div className={style['dot-spinner__dot']}></div>
			<div className={style['dot-spinner__dot']}></div>
			<div className={style['dot-spinner__dot']}></div>
			<div className={style['dot-spinner__dot']}></div>
			<div className={style['dot-spinner__dot']}></div>
		</div>
	);
};

export default Loading;
